import React, {useEffect, useState} from "react";
import {Alert, Button, ButtonGroup, Card, Col, Container, Form, Modal, Row} from 'react-bootstrap';
import {Redirect, useHistory} from "react-router-dom";
import {
    acceptLeadAPI,
    denyLeadAPI,
    getLeadAPI,
    setDocDeleted,
    updateLead,
    updateLeadValue
} from "../services/Leadservice";
import LoadingLoginScreen from "./LoadingLoginScreen";
import {downloadFinishedFile} from "../services/PandaDocService";
import {EmbedQuote} from "./document/EmbedQuote";

export default function LeadDetails({ match }) {

    let history = useHistory();

    const [errorText, setErrorText] = useState("");

    const [lead, setLead] = useState({});
    const [readOnly, setReadOnly] = useState(true);
    const [toDashboard, setToDashboard] = useState(false)
    const [showImage, setShowImage] = useState(false);
    const [newDistrict, setNewDistrict] = useState(null);
    const [newEmail, setNewEmail] = useState(null);
    const [newFirstName, setNewFirstName] = useState(null);
    const [newLastName, setNewLastName] = useState(null);
    const [newPhonenumber, setNewPhonenumber] = useState(null);
    const [newZipcode, setNewZipcode] = useState(null);
    const [newNote, setNewNote] = useState(null);
    const [error, setError] = useState(false)
    const [errorType, setErrorType] = useState("success")
    const [show, setShow] = useState(false);
    const [price, setPrice] = useState();

    const [loading, setLoading] = useState(false)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showDelete, setShowDelete] = useState(false);
    const [showQuote, setShowQuote] = useState(false)
    const handleCloseDelete = () => setShowDelete(false);
    const handleShowDelete = () => setShowDelete(true);
    const handleCloseQuoteModal = () => setShowQuote(false)
    let timer;

    useEffect(() => {


        setLoading(true)


        const getSpecificLead = async () => {
            setLead(await getLeadAPI(match.params.id));
        }
        getSpecificLead().then(() => {
            setError(true);
            setErrorText("Lead inladdad");
            setErrorType("success");
            timer = setTimeout(() => {
                setError(false)
            }, 5000)

        })


        clearTimeout(timer);
        setLoading(false)
    }, [match.params.id])

    if (toDashboard === true) {
        return <Redirect to='/dashboard' />
    }


    const updateFormsData = () => {

        let newValue = Number(price);
        try {

            updateLead(match.params.id, newDistrict, newEmail, newFirstName, newLastName, newPhonenumber, newZipcode, newNote, newValue).then(() => window.location.reload());

        } catch (e) {
            alert(e);
        }
    }


    const deleteLead = () => {


        try {
            setDocDeleted(match.params.id).then(() => setToDashboard(true));

        } catch (e) {
            alert(e);
        }
    }

    const handleDenyLead = async () => {

        try {
            denyLeadAPI(match.params.id).then(() => window.location.reload())

        } catch (err) {


        }
    }
    const handleAcceptLead = async () => {

        try {
            acceptLeadAPI(match.params.id).then(() => window.location.reload())

        } catch (err) {

        }
    }
    const displayCustomer = (text) => {
        switch (text) {
            case 'Privatperson':
                return "Privat Person"

            case 'Företag':
                return "Företag"

            case 'Byggherre/Entreprenör':
                return "Byggherre/Entreprenör"

            case 'Bostadsrättsförening':
                return 'Bostadsrättsförening'

            case 'Kommun/myndighet':
                return 'Kommun/Myndighet'

            case 'Ideell förening':
                return 'Ideell förening';

            case 'Villaförening':
                return 'Villaförening'
        }
    }

    const handleDownloadFile = async () => {
        setLoading(true);

        try {

            await downloadFinishedFile(lead.pandadocID);
        } catch (e) {
        }

        setLoading(false);
    }

    const handlecreateinvoice = async () => {


        if (!lead.value) {
            setError(true)
            setErrorText("du måste ange ett pris, klicka på redigera för att ändra pris.")
        } else {
            setShowQuote(true)
        }
    }

    const renderCreateOrSendQuoteText = () => {
        switch(lead.pandadocID) {
            case "":
                return "Skapa Offert"
            
            default:
                return "Skicka Offert"
        }
    }


    const handleMoveToQuote = async () => {
        setLoading(true)


        if (price !== typeof "number" || "float" || price <= 0) {
            setError(true)
            setErrorText("prisproblem, scumbag, lös dig ffs")
        }

        try {

            await updateLeadValue(match.params.id, parseFloat(price))
            setShowQuote(false)
            history.push(`/lead/${match.params.id}/quote`)


        } catch (e) {
            setError(true)
            setErrorText("Ett fel uppstod ")
        }

        setLoading(false)

    }
    const convertTimeStringToNewDate = (value) => {

        let num = parseInt(value);

        let date = new Date(num);

        const currentDayOfMonth = date.getDate();
        const currentMonth = date.getMonth();
        const currentYear = date.getFullYear();
        return currentYear + " / " + (currentMonth + 1) + " / " + currentDayOfMonth;
    }


    return (
        <Container fluid>

            {loading ? <LoadingLoginScreen /> :


                <Row>
                    <Col>
                        <Card>
                            <Form>

                                <Row>
                                    <span style={{
                                        fontSize: 22,
                                        paddingRight: 20,
                                        color: "#5291CA"
                                    }}>{lead.firstname + " " + lead.lastname}</span>

                                    <Container>
                                        <span>Redigera detaljer </span>
                                        <Button onClick={() => setReadOnly(!readOnly)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="currentColor"
                                                className="bi bi-pencil" viewBox="0 0 16 16">
                                                <path
                                                    d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                            </svg>
                                        </Button>
                                    </Container>

                                </Row>

                                <Row>
                                    <Col>
                                        <span>Förnamn</span>
                                        <Form.Control readOnly={readOnly} placeholder="Förnamn"
                                            defaultValue={lead.firstname}
                                            onChange={(event => setNewFirstName(event.target.value))} />
                                    </Col>
                                    <Col>
                                        <span>Efternamn</span>
                                        <Form.Control readOnly={readOnly} placeholder="Efternamn"
                                            defaultValue={lead.lastname}
                                            onChange={(event => setNewLastName(event.target.value))} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span>E-post</span>
                                        <Form.Control readOnly={readOnly} placeholder="E-post" defaultValue={lead.email}
                                            onChange={(event => setNewEmail(event.target.value))} />
                                    </Col>
                                    <Col>
                                        <span>Telefonnummer</span>
                                        <Form.Control readOnly={readOnly} placeholder="Telefonnummer"
                                            defaultValue={lead.customerPhone}
                                            onChange={(event => setNewPhonenumber(event.target.value))} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span>Kommun</span>
                                        <Form.Control readOnly={readOnly} placeholder="Kommun"
                                            defaultValue={lead.district}
                                            onChange={(event => setNewDistrict(event.target.value))} />
                                    </Col>
                                    <Col>
                                        <span>Postnummer</span>
                                        <Form.Control readOnly={readOnly} placeholder="Postnummer"
                                            defaultValue={lead.commitAt}
                                            onChange={(event => setNewZipcode(event.target.value))} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span>Uppdrag ska utföras åt</span>
                                        <Form.Control readOnly={true} placeholder="Typ av kund"
                                            value={displayCustomer(lead.customerType)} />
                                    </Col>
                                    <Col>
                                        <span>Uppskattad budget</span>
                                        <Form.Control readOnly={true} placeholder="Budget"
                                            value={lead.estimatedBudget} />
                                    </Col>
                                </Row>
                                <Container fluid={"sm"}>
                                    <Row>
                                        <Col>
                                            <span>Önskad start</span>
                                            <Form.Control readOnly={true} placeholder="Önskad start"
                                                value={
                                                    convertTimeStringToNewDate(lead.desiredStart)} />
                                        </Col>
                                        <Col>
                                            <span>Önskad kontakttid</span>
                                            <Form.Control readOnly={true} placeholder="Önskad konstakttid"
                                                value={lead.wantsToGetContacted} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <span>Pris (Inklusive Moms)</span>
                                            <Form.Control readOnly={readOnly} placeholder="Pris"
                                                defaultValue={lead.value} //inklusive moms
                                                onChange={(event => setPrice(event.target.value))} />


                                        </Col>
                                        <Col>
                                            <Button variant="success" disabled={readOnly} onClick={handleShow}>
                                                Spara ändringar
                                            </Button>
                                        </Col>

                                    </Row>
                                </Container>
                            </Form>
                        </Card>
                    </Col>

                    <Col>

                        <Card>
                            <Col>
                                <Row>
                                    <h4>Beskrivning från kund: </h4>
                                    <hr />

                                    <h3>{lead.description}</h3>
                                    <hr />

                                </Row>
                            </Col>
                            {/*
                            <ShowAttachedFiles pandadocid={lead && lead.pandadocID}/>
                            */ }
                            <Form style={{ padding: '30px' }}>
                                <span><b>Valda tjänster</b></span>
                                <hr />
                                {lead.service}
                                <hr />
                                {lead.services ? (
                                    <Row>

                                        {lead.services.map((service) => {
                                            return (
                                                <div style={{
                                                    backgroundColor: "#5291CA",
                                                    color: "white",
                                                    paddingTop: 2,
                                                    paddingRight: 10,
                                                    paddingLeft: 10,
                                                    paddingBottom: 2,
                                                    borderRadius: 15,
                                                    width: 100,
                                                }}>
                                                    <span>{service}</span>
                                                </div>
                                            )
                                        })}
                                    </Row>
                                ) : null}

                                <br />
                                <span><b>Referens (medarbetare) som genererat Lead</b></span>
                                <Form.Control readOnly={true} placeholder="Referens"
                                    value={lead.reference?.toLowerCase()} />


                            </Form>

                            {lead.dealstage === "17878477" ?

                                <Row>


                                    {/*
                                    <Col xs={{span: 3}}>

                                        <Button variant={"primary"} disabled={loading}
                                                onClick={() => handleDownloadFile()}>

                                            Ladda Ner
                                            dokument</Button>
                                    </Col>
                                    */}

                                    <Col>
                                        <Alert variant={"success"}>
                                            Offert signerad av kund {lead.email}
                                        </Alert>
                                    </Col>
                                    <Col>
                                        <ButtonGroup>
                                            <EmbedQuote
                                                pandadocid={lead.pandadocID}
                                                fsdocID={match.params.id}
                                                email={lead.email}
                                            />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                                :
                                <Row>
                                 
                                    {error ? <Alert variant={errorType}>{errorText}</Alert> : null}

                                    <Row xs={{ span: 3 }}>
                                        <Col>
                                        {lead.approved ? 
                                        
                                        <Button variant="success" onClick={handlecreateinvoice}>{renderCreateOrSendQuoteText()}</Button> 
                                        : 
                                        <Button variant="success" onClick={handleAcceptLead}>Godkänn
                                                Lead</Button> }
                                        <Button variant="warning" onClick={handleDenyLead}>Neka Lead</Button>
                                                                                   
                                        </Col>
                                    </Row>
                                </Row>
                            }
                        </Card>

                    </Col>


                </Row>
            }

            {/*Radera Modal*/}
            <Modal show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header>
                    <Modal.Title>Radera Lead</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Vill du ta bort denna Lead permanent? Borttagen lead hamnar under arkiv</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDelete}>
                        Avbryt
                    </Button>
                    <Button variant="danger" onClick={deleteLead}>
                        Radera
                    </Button>
                </Modal.Footer>
            </Modal>


            {/*GÅ VIDARE TILL QUOTE.js*/}
            <Modal show={showQuote} onHide={() => handleMoveToQuote}>
                <Modal.Header>
                    <Modal.Title>Bekräfa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Gå vidare</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseQuoteModal}>
                        Avbryt
                    </Button>
                    <Button variant="primary" onClick={handleMoveToQuote}>
                        Fortsätt
                    </Button>
                </Modal.Footer>
            </Modal>

            {/*Spara ändringar Modal*/}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Bekräfta ändringar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {newFirstName != null &&
                        <Row>
                            <span>Förnamn: {newFirstName}</span>
                        </Row>
                    }
                    {newLastName != null &&
                        <Row>
                            <span>Efternamn: {newLastName}</span>
                        </Row>
                    }
                    {newEmail != null &&
                        <Row>
                            <span>Email: {newEmail}</span>
                        </Row>
                    }
                    {newPhonenumber != null &&
                        <Row>
                            <span>Telefonnummer: {newPhonenumber}</span>
                        </Row>
                    }
                    {newDistrict != null &&
                        <Row>
                            <span>Kommun: {newDistrict}</span>
                        </Row>
                    }
                    {newZipcode != null &&
                        <Row>
                            <span>Postnummer: {newZipcode}</span>
                        </Row>
                    }

                    {price != null &&
                        <Row>
                            <span>Pris: {price} (Inklusive moms)</span>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Avbryt
                    </Button>
                    <Button variant="primary" onClick={updateFormsData}>
                        Spara ändringar
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>


    )
}
